import { Input, Select, Button, Row, Col, Tooltip } from "antd";
import { SearchOutlined, AppstoreOutlined, UnorderedListOutlined, ClearOutlined } from "@ant-design/icons";

const NAVY = "#042956";

const ESTADO_FINALIZACION_OPTIONS = [
  { label: "Finalizado", value: "finalizado" },
  { label: "Pendiente por finalizar", value: "pendiente" }
];

/**
 * ProyectosFilters
 * Props:
 *  - search: string
 *  - onSearchChange(value)
 *  - estado: string | undefined
 *  - onEstadoChange(value)
 *  - estadosDisponibles: string[]
 *  - estadoFinalizacion: "finalizado" | "pendiente" | undefined
 *  - onEstadoFinalizacionChange(value)
 *  - viewMode: "cards" | "list"
 *  - onViewModeChange(mode)
 *  - onReset()
 */
export default function ProyectosFilters({
  search,
  onSearchChange,
  estado,
  onEstadoChange,
  estadosDisponibles = [],
  estadoFinalizacion,
  onEstadoFinalizacionChange,
  viewMode = "cards",
  onViewModeChange,
  onReset
}) {
  const toggleBtnBase = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 40,
    height: 40,
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
    fontSize: 18,
    transition: "all 0.2s ease"
  };

  const activeToggle = {
    ...toggleBtnBase,
    background: NAVY,
    color: "#ffffff"
  };

  const inactiveToggle = {
    ...toggleBtnBase,
    background: "transparent",
    color: "#8c9bab"
  };

  return (
    <div
      style={{
        background: "#ffffff",
        borderRadius: 16,
        padding: 16,
        boxShadow: "0 1px 4px rgba(4, 41, 86, 0.06)",
        border: "1px solid #eef1f5",
        marginBottom: 20
      }}
    >
      <Row gutter={[12, 12]} align="middle">
        <Col xs={24} sm={24} md={8} lg={8}>
          <Input
            allowClear
            size="large"
            value={search}
            onChange={(e) => onSearchChange?.(e.target.value)}
            placeholder="Buscar por código o nombre de proyecto…"
            prefix={<SearchOutlined style={{ color: "#8c9bab" }} />}
            style={{ borderRadius: 10 }}
          />
        </Col>
        <Col xs={12} sm={12} md={5} lg={5}>
          <Select
            allowClear
            size="large"
            value={estadoFinalizacion}
            onChange={(value) => onEstadoFinalizacionChange?.(value)}
            placeholder="Informe técnico final"
            style={{ width: "100%" }}
            options={ESTADO_FINALIZACION_OPTIONS}
          />
        </Col>

        <Col xs={12} sm={8} md={3} lg={3}>
          <Button
            size="large"
            icon={<ClearOutlined />}
            onClick={() => onReset?.()}
            style={{ width: "100%", borderRadius: 10, color: NAVY, borderColor: "#d7dee7" }}
          >
            Limpiar
          </Button>
        </Col>

        <Col xs={12} sm={16} md={3} lg={3}>
          <div
            style={{
              display: "flex",
              gap: 4,
              padding: 4,
              background: "#f2f5f9",
              borderRadius: 10,
              justifyContent: "center",
              marginLeft: "auto",
              width: "fit-content",
              float: "right"
            }}
          >
            <Tooltip title="Vista de tarjetas">
              <button
                type="button"
                aria-label="Vista de tarjetas"
                style={viewMode === "cards" ? activeToggle : inactiveToggle}
                onClick={() => onViewModeChange?.("cards")}
              >
                <AppstoreOutlined />
              </button>
            </Tooltip>
            <Tooltip title="Vista de lista">
              <button
                type="button"
                aria-label="Vista de lista"
                style={viewMode === "list" ? activeToggle : inactiveToggle}
                onClick={() => onViewModeChange?.("list")}
              >
                <UnorderedListOutlined />
              </button>
            </Tooltip>
          </div>
        </Col>
      </Row>
    </div>
  );
}
